import { render, staticRenderFns } from "./OperatePermissionDialog.vue?vue&type=template&id=03278348&scoped=true"
import script from "./OperatePermissionDialog.vue?vue&type=script&lang=js"
export * from "./OperatePermissionDialog.vue?vue&type=script&lang=js"
import style0 from "./OperatePermissionDialog.vue?vue&type=style&index=0&id=03278348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03278348",
  null
  
)

export default component.exports